/** 对应版本站点清理 */
export const VERSION_CLEARED = 'version-cleared';

/** 默认语言 */
export const DEFAULT_LANG = 'en-US';

/**
 * 体育场景分类
 * 用于标识 All Sport 中的场景分类 Tab
 */
export enum EventCategory {
  /**
   * 首页的live-events，
   * 不区分体育类型，所以没有统一的玩法表头，每一条数据都可能是不同玩法
   */
  LOBBY_LIVE = 'lobby-live',

  /**
   * Live Events - 直播赛事场景
   */
  LIVE_EVENTS = 'live-events',

  /**
   * Upcoming - 即将开始赛事场景
   */
  UPCOMING = 'upcoming',

  /**
   * Outright - 冠军赛事场景
   */
  OUTRIGHT = 'outright',

  /**
   * All - 所有赛事场景
   */
  ALL = 'all',

  SPORT_PAGE_ONE = 'sportPageOne',

  SPORT_PAGE_TWO = 'sportPageTwo',

  SPORT_PAGE_THREE = 'sportPageThree',
}

/**
 * Betting Highlights 推单类型
 */
export enum BettingHighlightsType {
  /**
   * combo 单
   */
  COMBO = 'combo',

  /**
   * custom_bet 单
   */
  CUSTOM_BET = 'custom_bet',
}

/**
 * Betting Highlights 推单子类型
 */
export enum BettingHighlightsSubType {
  /**
   * 同运动，同联赛，不同比赛
   */
  S_LEAGUE_D_MATCH = 'same_league',

  /**
   * 同运动，不同联赛，不同比赛
   */
  D_LEAGUE_D_MATCH = 'cross_league',
}

/**
 * 投注类型映射
 */
export const BetTypeMap = {
  SINGLE: 'Single',
  COMBO: 'Combo',
  SYSTEM: 'System',
  CUSTOM: 'Custom Bet',
  OUTRIGHT: 'Outright',
} as const;

/**
 * 首页跟单统计类型
 */
export enum CopyType {
  BETTING_HIGHLIGHTS = 11,
  HOT_COMBO = 12,
}

/**
 * 盘口状态枚举
 */
export enum MarketStatus {
  /**
   * 激活
   * 已提供赔率,你可以在此盘口上正常接受投注
   */
  Active = 1,

  /**
   * 已暂停
   * 仍在提供赔率,但暂时不应接受投注
   * 例如:在进球前后暂停投注,直到进球被确认
   */
  Suspended = -1,

  /**
   * 停用/非激活
   * 当前盘口不再提供赔率,不过它有可能重新激活
   * 例如:3.5 总进球盘口在当前情况下不再平衡,被停用,但当有进球时,它又成为新的平衡盘口,从而重新激活
   * 这种状态变化是常见的
   */
  Deactivated = 0,

  /**
   * 已结算
   * 已发送该盘口的结算消息,不再提供新的赔率
   * 但在极少数错误情况下,结算后的盘口可能会被回滚为取消 (Cancelled)
   * 备注:在某些情况下,"已结算"的盘口可重新变为"激活"
   * 例如:一个进球被回看后判无效,相关盘口(如"首个进球")会重新变为可投注状态
   */
  Settled = -3,

  /**
   * 已取消
   * 该盘口已被取消,不再提供任何赔率
   * 此状态通常在恢复过程(recovery)中出现,表示系统已发送过取消该盘口的消息
   */
  Cancelled = -4,

  /**
   * 已交接
   * 非真实盘口状态,而是一种生产者间交接信号
   * 表示该盘口的赔率将由另一生产者接管
   * 常见于 Prematch → Live Odds 的切换阶段
   * 如果尚未收到新生产者的赔率,应先将盘口标记为"暂停";若已收到新赔率,则可忽略该信号
   * 备注:如果交接状态后60秒内没有新的赔率更新,应视为异常并将盘口处理为"停用"
   */
  HandedOver = -2,
}

/**
 * 赔率市场盘口下面的 投注项状态
 */
export enum OutcomeStatus {
  // 投注项有效
  Active = 1,

  // 投注项无效
  Inactive = 0,
}

export const SPORTS_RADAR_LANGS = ['en', 'zh', 'zht', 'th', 'vi', 'id', 'ja', 'ko', 'el', 'pl', 'tr', 'pt'];
